import { usePathname } from "next/navigation";

import { stripLanguagePrefix } from "@/utils/language";

const TRAILING_SLASH_OFFSET = -1;

interface UseActivePathResult {
  isActive: (href: string) => boolean;
}

function normalizePath(path: string): string {
  const normalizedPath = stripLanguagePrefix(path);
  if (normalizedPath.length <= 1 || !normalizedPath.endsWith("/")) {
    return normalizedPath;
  }

  return normalizedPath.slice(0, TRAILING_SLASH_OFFSET);
}

export function useActivePath(): UseActivePathResult {
  const pathname = usePathname() ?? "";
  const currentPath = normalizePath(pathname);

  function isActive(href: string): boolean {
    const destinationPath = normalizePath(href);

    if (destinationPath === "/") {
      return currentPath === destinationPath;
    }

    return currentPath === destinationPath || currentPath.startsWith(`${destinationPath}/`);
  }

  return { isActive };
}
